import React, { useEffect, useState, useContext } from "react";
import Cookies from "js-cookie";
import CopyDiv from "../../components/CopyDiv/CopyDiv.js";

import "./Orders.css";
import { TypeAnimation } from "react-type-animation";
import SlotNumber from "../../components/SlotNumber/SlotNumber.js";

import marketplaces from "../../config/marketplaces.json";

import { UserContext } from "../../App.js";

const statuses = {
    0: {
        id: 0,
        text: "Processando",
        color: "#212121",
        information: "Seu pedido está sendo embalado na velocidade da luz e logo estará disponível para coleta/envio.",
    },
    1: {
        id: 1,
        text: "Embalado",
        color: "#1567D2",
        information: "Seu pedido já foi embalado. Acompanhe o envio pelo marketplace ou pelo site da transportadora.",
    },
    2: {
        id: 2,
        text: "Cancelado",
        color: "#c93838",
        information: "Esse pedido foi cancelado, então não houve cobrança ou seu saldo foi estornado.",
    },
    3: {
        id: 3,
        text: "Pendente",
        color: "#c93838",
        information: "Seu pedido está pendente! Verifique todos os dados na sua plataforma integradora e no marketplace.",
    },
    4: {
        id: 4,
        text: "Saldo insuficiente",
        color: "#c93838",
        information:
            "Você não tem saldo o suficiente para completar esse pedido! Por favor, insire saldo para que seu pedido não atrase.",
    },
};

const getPlpImage = (plpUrl) => {
    return new Promise(async (resolve, reject) => {
        if (!plpUrl) reject();
        const plpResponse = await fetch(`/uploads/orders/${plpUrl}`).catch(reject);
        let plpData = await plpResponse.text();
        if (!plpData) reject();
        const response = await fetch("https://api.labelary.com/v1/printers/8dpmm/labels/4x6/0/", {
            method: "POST",
            body: plpData,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        });
        let blob = await response.blob();

        blobToBase64(blob, function (image) {
            resolve(`data:image/png;base64,${image}`);
        });
    });
};

export default function Orders() {
    const { orders } = useContext(UserContext);

    const [search, setSearch] = useState("");

    const [modalOrder, setModalOrder] = useState(false);
    const [modalOrderObj, setModalOrderObj] = useState({});

    const [modalPlp, setModalPlp] = useState(false);
    const [modalNfe, setModalNfe] = useState(false);
    const [modalCancel, setModalCancel] = useState(false);

    const [plp, setPlp] = useState(false);

    const [boxQtty, setBoxQtty] = useState(0);
    const [giftQtty, setGiftQtty] = useState(0);

    useEffect(() => {
        modalOrderObj.order_products &&
            setGiftQtty(
                Object.keys(modalOrderObj.order_products).reduce((accumulator, key) => {
                    let value = modalOrderObj.order_products[key];
                    return accumulator + (value.options.gift ? (value.options.globalGift == 1 ? 1 : value.qtty) : 0);
                }, 0)
            );

        modalOrderObj.order_products &&
            setBoxQtty(
                Object.keys(modalOrderObj.order_products).reduce((accumulator, key) => {
                    let value = modalOrderObj.order_products[key];
                    return accumulator + (value.options.box ? value.options.boxQtty : 0);
                }, 0)
            );
    }, [modalOrderObj]);

    const [hideSearch, setHideSearch] = useState(false);
    const [ordersSearch, setOrdersSearch] = useState([]);

    useEffect(() => {
        if (!search) return setOrdersSearch(Object.values(orders).reverse());
        let query = search.toLowerCase();
        let newOrders = Object.values(orders)
            .reverse()
            .filter((order) => {
                let skus = order.order_products.map((e) => e.product.sku.toLowerCase()).join(" ");
                let date = new Date(order.createdAt)
                    .toLocaleString()
                    .split(", ")
                    .reverse()
                    .join("\n")
                    .replace(/(:\d\d\n)/, "\n");
                return (
                    skus.includes(query) ||
                    date.includes(query) ||
                    order.id.toString().padStart(6, 0).includes(query) ||
                    marketplaces[order.marketplace].name.toLowerCase().includes(query) ||
                    query.includes(marketplaces[order.marketplace].name.toLowerCase()) ||
                    order.data?.contato?.nome?.toLowerCase().includes(query)
                );
            });
        setOrdersSearch(newOrders);
    }, [orders, search]);

    return (
        <>
            <div className={`order-modal-bg ${modalOrder ? "shown" : ""}`} onClick={() => setModalOrder(false)}>
                <div className="order-modal" onClick={(ev) => ev.stopPropagation()}>
                    <div className="order-modal-header">
                        <div className="order-modal-header-section order-modal-number">
                            <small>Pedido nº</small>
                            {modalOrder ? (
                                <SlotNumber delay={500} number={("" + modalOrderObj.id).padStart(6, 0)} height={20} />
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="order-modal-header-section order-modal-date">
                            {new Date(modalOrderObj.createdAt)
                                .toLocaleString()
                                .split(", ")
                                .reverse()
                                .join("\n")
                                .replace(/(:\d\d\n)/, "\n")}
                        </div>
                        <div className="order-modal-header-section order-marketplace">
                            <img src={marketplaces[modalOrderObj.marketplace]?.img} />
                        </div>
                        <div className="order-modal-header-section order-buttons">
                            <div
                                className={`order-button ${
                                    !modalOrderObj.plp || (modalOrderObj.plp === "error" && modalOrderObj.status === 3)
                                        ? "notfound"
                                        : ""
                                }`}
                            >
                                <div className="order-button-bubble">PLP</div>
                                <img
                                    src="/img/orders/plp.svg"
                                    onClick={async (ev) => {
                                        ev.stopPropagation();
                                        if (!modalOrderObj.plp) return;
                                        setModalPlp(true);
                                        setPlp(await getPlpImage(modalOrderObj.plp));
                                    }}
                                />
                            </div>
                            <div className={`order-button ${!modalOrderObj.nfe && modalOrderObj.status === 3 ? "notfound" : ""}`}>
                                <div className="order-button-bubble">NFe</div>
                                <img
                                    src="/img/orders/nfe.svg"
                                    onClick={(ev) => {
                                        ev.stopPropagation();
                                        setModalNfe(true);
                                    }}
                                />
                            </div>
                        </div>
                        {[0, 3, 4].includes(modalOrderObj.status) ? (
                            <div
                                className="order-modal-cancel"
                                onClick={() => {
                                    setModalCancel(true);
                                }}
                            >
                                Cancelar
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    <div className="order-modal-body">
                        {modalOrderObj.data && modalOrderObj.data.numeroLoja ? (
                            <div className="order-modal-details">
                                <CopyDiv className="order-modal-marketplaceid" value={modalOrderObj.data.numeroLoja}>
                                    #{modalOrderObj.data.numeroLoja}
                                </CopyDiv>
                                <CopyDiv className="order-modal-buyername" value={modalOrderObj.data?.contato?.nome || ""}>
                                    {modalOrderObj.data?.contato?.nome || ""}
                                </CopyDiv>
                            </div>
                        ) : (
                            ""
                        )}
                        <div className="order-status-block">
                            {modalOrder ? (
                                <div className="order-timeline">
                                    <div
                                        className={`order-timeline-circle ${
                                            modalOrderObj.status === 3 || modalOrderObj.status === 4 ? "pending" : ""
                                        } ${modalOrderObj.status === 3 || modalOrderObj.status === 4 ? "advance" : "advanced"}`}
                                    >
                                        <div className="order-timeline-subtitle">
                                            {modalOrderObj.status === 4 ? "Sem saldo" : "Pendente"}
                                        </div>
                                    </div>
                                    <div
                                        className={`order-timeline-line ${
                                            modalOrderObj.status === 3 || modalOrderObj.status === 4
                                                ? "pending advance"
                                                : modalOrderObj.status === 0
                                                ? "advance"
                                                : modalOrderObj.status === 1
                                                ? "advanced"
                                                : "advanced"
                                        }`}
                                    ></div>
                                    <div
                                        className={`order-timeline-circle ${
                                            modalOrderObj.status === 0
                                                ? "advance"
                                                : modalOrderObj.status === 1
                                                ? "advanced"
                                                : modalOrderObj.status === 2
                                                ? "advanced"
                                                : ""
                                        }`}
                                    >
                                        <div className="order-timeline-subtitle">Processando</div>
                                    </div>
                                    {modalOrderObj.status === 2 ? (
                                        <>
                                            <div
                                                className={`order-timeline-line canceled ${
                                                    modalOrderObj.status === 2 ? "advance" : ""
                                                }`}
                                            ></div>
                                            <div
                                                className={`order-timeline-circle canceled ${
                                                    modalOrderObj.status === 2 ? "advance" : ""
                                                }`}
                                            >
                                                <div className="order-timeline-subtitle canceled">Cancelado</div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div
                                                className={`order-timeline-line ${modalOrderObj.status === 1 ? "advance" : ""}`}
                                            ></div>
                                            <div
                                                className={`order-timeline-circle ${modalOrderObj.status === 1 ? "advance" : ""}`}
                                            >
                                                <div className="order-timeline-subtitle">Embalado</div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ) : (
                                ""
                            )}
                            <div className="order-status-explanation">
                                {statuses[modalOrderObj.status || 0].information}
                                {modalOrderObj.options?.cancelReason ? (
                                    <div className="cancel-reason-container">
                                        Motivo do cancelamento:{" "}
                                        <div className="cancel-reason">{modalOrderObj.options.cancelReason}</div>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                        <div className="order-modal-products-shadow">
                            <div className="order-modal-products">
                                {modalOrder
                                    ? modalOrderObj.order_products.map((e, i) => {
                                          if (
                                              modalOrderObj.order_products[i - 1] &&
                                              modalOrderObj.order_products[i - 1].product.id === e.product.id
                                          )
                                              return;

                                          let giftQtty = modalOrderObj.order_products
                                              .filter((p) => p.product.id === e.product.id)
                                              .reduce((accum, curr) => {
                                                  if (Object.values(curr?.options).find((f) => f.name === "gift"))
                                                      return accum + 1;
                                                  else return accum;
                                              }, 0);
                                          let boxQtty = modalOrderObj.order_products
                                              .filter((p) => p.product.id === e.product.id)
                                              .reduce((accum, curr) => {
                                                  if (Object.values(curr?.options).find((f) => f.name === "box"))
                                                      return accum + 1;
                                                  else return accum;
                                              }, 0);
                                          return (
                                              <div
                                                  className="order-modal-product"
                                                  style={{
                                                      animationDelay: `${i * 30 + 350}ms`,
                                                  }}
                                                  key={i}
                                              >
                                                  <div className="order-modal-product-sku">{e.product.sku}</div>
                                                  <div className="order-modal-product-image">
                                                      <img src={`/uploads/thumbs/${e.product.photos[0]}`} />
                                                      <div className={`order-product-qtty ${e.qtty > 1 ? "shown" : ""}`}>
                                                          {e.qtty}
                                                      </div>
                                                  </div>
                                                  <div className="order-modal-product-price">
                                                      <small>R$</small> {e.price}
                                                  </div>
                                                  <div className="order-modal-product-options">
                                                      {Object.values(e.options).find((f) => f.name === "box") ? (
                                                          <div className="order-product-option">
                                                              {boxQtty} x
                                                              <img src="/img/caixa.svg" />=
                                                              <span>
                                                                  <small>R$ </small>
                                                                  {boxQtty * 5}
                                                              </span>
                                                          </div>
                                                      ) : (
                                                          ""
                                                      )}

                                                      {Object.values(e.options).find((f) => f.name === "gift") ? (
                                                          <div className="order-product-option">
                                                              {giftQtty} x
                                                              <img src="/img/presente.svg" />=
                                                              <span>
                                                                  <small>R$ </small>
                                                                  {giftQtty * 2}
                                                              </span>
                                                          </div>
                                                      ) : (
                                                          ""
                                                      )}
                                                  </div>
                                              </div>
                                          );
                                      })
                                    : ""}
                            </div>
                        </div>
                    </div>
                    <div className="order-modal-total">
                        <div className="order-modal-total-section order-modal-options">
                            {giftQtty ? (
                                <div className="order-modal-option">
                                    {giftQtty}x<img src="/img/presente.svg" />
                                    <div className="order-modal-option-price">
                                        <small>R$ </small>
                                        {giftQtty * 2}
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            {boxQtty ? (
                                <div className="order-modal-option">
                                    {boxQtty}x<img src="/img/caixa.svg" />
                                    <div className="order-modal-option-price">
                                        <small>R$ </small>
                                        {boxQtty * 5}
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="order-modal-total-section">
                            Pago
                            <span className="order-modal-total-value">
                                <small>R$ </small>
                                {modalOrderObj.price}
                            </span>
                        </div>
                        <div className="order-modal-total-section">
                            Vendido
                            <span className="order-modal-total-value">
                                <small>R$ </small>
                                {(modalOrderObj.earned || 0).toFixed(2).replace(".", ",")}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`order-modal-bg ${modalCancel ? "shown" : ""}`} onClick={() => setModalCancel(false)}>
                <div className="order-modal order-cancel" onClick={(ev) => ev.stopPropagation()}>
                    Tem certeza que deseja
                    <br /> cancelar o pedido?
                    <div className="cancel-btns">
                        <div className="cancel-btn-no" onClick={() => setModalCancel(false)}>
                            Não
                        </div>
                        <div
                            className="cancel-btn-yes"
                            onClick={async () => {
                                await fetch("/api/orders/cancel", {
                                    method: "POST",
                                    body: JSON.stringify({
                                        orderId: modalOrderObj.id,
                                    }),
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: "Bearer " + Cookies.get("jwt"),
                                    },
                                });
                                setModalCancel(false);
                                setModalOrder(false);
                            }}
                        >
                            Sim
                        </div>
                    </div>
                </div>
            </div>
            <div className={`order-modal-bg ${modalNfe ? "shown" : ""}`} onClick={() => setModalNfe(false)}>
                <div className="order-modal order-modal-plp order-modal-nfe" onClick={(ev) => ev.stopPropagation()}>
                    <iframe
                        src={
                            `${window.location.protocol}//${
                                window.location.hostname == "localhost"
                                    ? `${window.location.hostname}:5000`
                                    : window.location.hostname
                            }/uploads/orders/` + modalOrderObj.nfe
                        }
                        type="application/pdf"
                        width="400px"
                        height="550px"
                    />
                </div>
            </div>

            <div
                className={`order-modal-bg ${modalPlp ? "shown" : ""}`}
                onClick={() => {
                    setModalPlp(false);
                    setPlp(null);
                }}
            >
                <div className="order-modal order-modal-plp" onClick={(ev) => ev.stopPropagation()}>
                    <img className="plp-img" src={plp} />
                </div>
            </div>
            <div className="order-list">
                {/*JSON.stringify(orders)*/}
                {ordersSearch.map((order, index) => {
                    return (
                        <Order
                            setModalNfe={setModalNfe}
                            setPlp={setPlp}
                            setModalPlp={setModalPlp}
                            setModalOrderObj={setModalOrderObj}
                            order={order}
                            index={index}
                            key={order.id}
                            onClick={() => {
                                setModalOrderObj(order);
                                setModalOrder(true);
                            }}
                        />
                    );
                })}
            </div>
            <div className="order-search-bar">
                <div className="order-search">
                    <input
                        // className="order-search"
                        placeholder="Pesquise por nº do pedido, sku, data, etc..."
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            // setSearchParams({'q': e.target.value});
                        }}
                        onFocus={() => setHideSearch(true)}
                    />
                    <div className="order-search-qtty">
                        {ordersSearch.length ? `${ordersSearch.length} Pedido${ordersSearch.length > 1 ? "s" : ""}` : ""}
                    </div>
                </div>
                <div className={`order-search-placeholder ${hideSearch ? "hidden" : ""}`}>
                    <TypeAnimation
                        sequence={[1500, "Pesquise por nº do pedido, sku, data, etc..."]}
                        // wrapper="span"
                        speed={{ type: "keyStrokeDelayInMs", value: 25 }}
                    />
                </div>
            </div>
        </>
    );
}

function Order(props) {
    const status = statuses[props.order.status];

    return (
        <div className="order-card" onClick={props.onClick} style={{ animationDelay: `${props.index * 50}ms` }}>
            <div className="order-section order-photo">
                {props.order.order_products.length > 1 ? (
                    <div className="multiple-order-photos">
                        <img src={`/uploads/thumbs/${props.order.order_products[0].product.photos[0]}`} />
                        <img src={`/uploads/thumbs/${props.order.order_products[1].product.photos[0]}`} />
                        <img
                            src={`/uploads/thumbs/${
                                props.order.order_products[2]
                                    ? props.order.order_products[2].product.photos[0]
                                    : props.order.order_products[1].product.photos[0]
                            }`}
                        />
                    </div>
                ) : (
                    <img
                        src={`/uploads/thumbs/${
                            props.order.order_products[0] ? props.order.order_products[0].product.photos[0] : "ff.jpg"
                        }`}
                    />
                )}
                <div className="order-photo-sku">
                    {props.order.order_products.length > 1
                        ? "Diversos"
                        : props.order.order_products[0]
                        ? props.order.order_products[0].product.sku
                        : "ERRO"}
                </div>
            </div>
            <CopyDiv className="order-section order-number" value={("" + props.order.id).padStart(6, 0)}>
                {("" + props.order.id).padStart(6, 0)}
            </CopyDiv>
            <div className="order-section order-price">
                <div className="order-price-internal">
                    Pago
                    <div className="order-price-value">
                        <small>R$</small> {props.order.price}
                    </div>
                </div>
                <div className="order-price-internal">
                    Vendido
                    <div className="order-price-value">
                        <small>R$</small> {(props.order.earned || props.order.price).toFixed(2).replace(".", ",")}
                    </div>
                </div>
            </div>
            <div className="order-section order-marketplace">
                <img src={marketplaces[props.order.marketplace]?.img} />
                {props.order.idBling ? <img className="order-bling-icon" src="/img/orders/bling.svg" /> : <></>}
            </div>
            <div className="order-section order-buttons">
                {/* <div
                    className={`order-message order-button ${
                        Math.random() > 2 ? "new-messages" : ""
                    }`}
                >
                    <div className="order-button-bubble">Mensagens</div>
                    <img src="/img/orders/message.svg" className="no-message" />
                    <div className="with-message">
                        <img src="/img/orders/message-filled.svg" />
                        <span className="order-message-qtty">
                            {Math.round(Math.random() * 9 + 1)}
                        </span>
                    </div>
                </div> */}
                <div
                    className={`order-button ${
                        !props.order.plp || (props.order.plp === "error" && props.order.status === 3) ? "notfound" : ""
                    }`}
                >
                    <div className="order-button-bubble">PLP</div>
                    <img
                        src="/img/orders/plp.svg"
                        onClick={async (ev) => {
                            ev.stopPropagation();
                            if (!props.order.plp) return;
                            props.setModalPlp(true);
                            props.setPlp(await getPlpImage(props.order.plp));
                        }}
                    />
                </div>
                <div className={`order-button ${!props.order.nfe && props.order.status === 3 ? "notfound" : ""}`}>
                    <div className="order-button-bubble">NFe</div>
                    <img
                        src="/img/orders/nfe.svg"
                        onClick={(ev) => {
                            ev.stopPropagation();
                            if (!props.order.nfe) return;
                            props.setModalOrderObj(props.order);
                            props.setModalNfe(true);
                        }}
                    />
                </div>
            </div>
            <div className="order-section order-date">
                {new Date(props.order.createdAt)
                    .toLocaleString()
                    .split(",")
                    .reverse()
                    .join("\n")
                    .replace(/(:\d\d\n)/, "\n")}
            </div>
            <div className="order-section order-status" style={{ backgroundColor: status.color }}>
                {status.text}
                <div className="order-status-bubble">{status.information}</div>
            </div>
        </div>
    );
}

var blobToBase64 = function (blob, callback) {
    var reader = new FileReader();
    reader.onload = function () {
        var dataUrl = reader.result;
        var base64 = dataUrl.split(",")[1];
        callback(base64);
    };
    reader.readAsDataURL(blob);
};
